import gql from 'graphql-tag';

export default gql`
    mutation StopJobLog($input: StopJobLogInput) {
        stopJobLog(input: $input) {
            errors
        }
    }
`;
